const getFileNameFromContentDisposition = (
  contentDisposition: string | null,
  defaultFieName = "fileName.zip"
): string => {
  if (!contentDisposition) {
    return defaultFieName;
  }

  const pattern = /filename=(["']?)(.+)\1/i;
  const result = contentDisposition.match(pattern);

  if (result) {
    return result[2];
  }

  return defaultFieName;
};

export default getFileNameFromContentDisposition;
